import { useDrop } from 'react-dnd'

import { Box } from '@factorialco/deprecated-design-system'

import { DRAG_TYPE, DragItemInfo } from './SidebarElement'

const SectionPlaceHolder = ({
  index,
  sectionId,
  onHover,
  onDrop,
}: {
  index: number
  sectionId: string | null
  onHover: (elementId: string, toSectionId: string | null, toIndex: number) => void
  onDrop: (elementId: string, toPosition: number, toSectionId: string | null) => void
}) => {
  const [, drop] = useDrop(
    {
      accept: DRAG_TYPE,
      hover(item: DragItemInfo, monitor) {
        if (!monitor.canDrop()) return

        if (item.isSection) return

        if (item.toIndex === index && item.toSectionId === sectionId) return
        onHover(item.id, sectionId, index)
        item.toIndex = index
        item.toSectionId = sectionId
      },
      drop(item: DragItemInfo) {
        //do nothing if dropped in the original position
        if (item.fromIndex === item.toIndex && item.fromSectionId === item.toSectionId) return
        onDrop(item.id, item.toIndex, item.toSectionId)
      },
      canDrop(draggingElement: DragItemInfo) {
        const placeHolderIsForm = !sectionId
        const draggingASectionIntoASection = draggingElement.isSection && sectionId
        const draggingAnElementInSameSection =
          !draggingElement.isSection && draggingElement.toSectionId === sectionId
        const canDrop = !draggingASectionIntoASection && !draggingAnElementInSameSection
        return placeHolderIsForm || canDrop
      },
    },
    [index, sectionId]
  )

  return <Box ref={drop} minHeight="s12"></Box>
}
export default SectionPlaceHolder
